export class IdhaAppException extends Error {
    constructor(public msg?:string) {
        super(msg)
    }
}